import { SAVE_WEDDING, UPDATE_QUESTION, UPDATE_ANSWERS, UPDATE_ABOUT_US, SAVE_CONTACT_CONFIRMATION } from "../ActionsType";

const wedding = {};

const findQuestion = (structure, tag, id) => {
  let found = false;
  let sectionIndex = 0;
  let ChapterIndex = 0;
  let QuestionIndex = 0;

  structure.forEach((section, sIndex) => {
    if(section.tag === tag) {
      sectionIndex = sIndex;
      section.chapters.forEach((chapter, cIndex) => {
        chapter.questions.forEach((question, qIndex) => {
          if(question._id === id) {
            found = true;
            ChapterIndex = cIndex;
            QuestionIndex = qIndex;
          }
        });
      });
    }
  });

  return { sectionIndex, ChapterIndex, QuestionIndex, found };
};

const updateQuestion = (state, tag, data) => {
  const result = { ...state };
  const { sectionIndex, ChapterIndex, QuestionIndex, found } = findQuestion(result.structure, tag, data.question);

  if(found) {
    result.structure[sectionIndex].chapters[ChapterIndex].questions[QuestionIndex].answer = data;
  }

  return result;
};

const updateAnswers = (state, answers) => {
  console.warn('[updateAnswers] called with', Array.isArray(answers) ? answers.length : 'non-array', 'answers', answers);
  if (!Array.isArray(answers) || answers.length === 0) return state;
  const result = { ...state };
  const structure = result.structure;
  if (!structure) {
    console.warn('[updateAnswers] no structure in state, skipping');
    return state;
  }

  const idx = {};
  structure.forEach((section, sIdx) => {
    (section.chapters || []).forEach((chapter, cIdx) => {
      (chapter.questions || []).forEach((question, qIdx) => {
        idx[String(question._id)] = { sIdx, cIdx, qIdx };
      });
    });
  });

  answers.forEach(ans => {
    const qid = String(ans.question?._id || ans.question);
    const loc = idx[qid];
    if (!loc) {
      console.warn('[updateAnswers] question NOT found in structure:', qid);
      return;
    }
    console.warn('[updateAnswers] updating question', qid, 'at', loc, 'new response.length=', Array.isArray(ans.response) ? ans.response.length : 'n/a');
    structure[loc.sIdx].chapters[loc.cIdx].questions[loc.qIdx].answer = ans;
  });

  return result;
};

const updateAboutUs = (state, data) => {
  const result = { ...state };
  
  result.wedding = data;

  return result;
};

export default (state = wedding, action) => {
  switch (action.type) {
    case SAVE_WEDDING:
      return { ...action.wedding };
    case UPDATE_QUESTION:
      return updateQuestion(state, action.section, action.data);
    case UPDATE_ANSWERS:
      return updateAnswers(state, action.answers);
    case UPDATE_ABOUT_US:
      return updateAboutUs(state, action.data);
    case SAVE_CONTACT_CONFIRMATION:
      return { ...state, contactConfirmation: action.data };
    default:
      return state;
  }
};
